<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="filterByClassificator"
              label="Фильтровать по классификатору"
              hide-details
              class="mt-0"
            ></v-checkbox>
            <span class="text-caption text--secondary">
              Меню приходит из Delivery. Когда флаг включён, в витрину попадают
              только блюда, заведённые в указанной классификаторной группе r_keeper.
            </span>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="classificatorGroupId"
              label="Группа классификатора"
              hint="Например, 4352 — «Мобильное приложение»"
              persistent-hint
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-if="!restaurantsFailed"
              v-model="restaurantId"
              :items="restaurantItems"
              item-text="title"
              item-value="id"
              label="Ресторан"
              hint="Список берётся из r_keeper"
              persistent-hint
              dense
              outlined
            ></v-select>
            <v-text-field
              v-else
              v-model="restaurantId"
              label="Ресторан"
              hint="Касса недоступна, список не загрузился — введите ident вручную, 0 не ограничивает"
              persistent-hint
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-checkbox
              v-model="onlyActive"
              label="Только активные позиции"
              hide-details
              class="mt-0"
            ></v-checkbox>
            <span class="text-caption text--secondary">
              Выключенные в кассе блюда не приедут. Снимите флаг, если раздел
              приходит пустым, хотя позиции в нём заведены.
            </span>
          </v-col>

          <v-col cols="12">
            <v-divider class="mb-2"></v-divider>
            <span class="text-subtitle-2">Подарочный товар и приборы</span>
            <p class="text-caption text--secondary mb-0">
              Синхронизация берёт всё, что лежит в выбранных категориях Delivery — это папки кассы.
              Подарком и прибором годятся только бесплатные позиции; увидеть их и загрузить им
              картинки — в справочнике «Подарочный товар».
            </p>
            <v-alert
              v-if="categoriesFailed"
              type="warning"
              text
              dense
              class="mt-2 mb-0"
            >
              Delivery не ответил — список категорий не загрузился. Выбранные категории сохранятся как есть.
            </v-alert>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="presentCategoryIds"
              :items="categoryItems"
              item-value="id"
              item-text="title"
              label="Категории подарочного товара"
              hint="Например, «Подарки»: кола, спрайт, фанта"
              persistent-hint
              multiple
              chips
              small-chips
              deletable-chips
              dense
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="applianceCategoryIds"
              :items="categoryItems"
              item-value="id"
              item-text="title"
              label="Категории приборов"
              hint="Например, «Разовая посуда»: приборы, палочки, соус"
              persistent-hint
              multiple
              chips
              small-chips
              deletable-chips
              dense
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'

export default {
  name: 'MenuSyncSettingForm',
  data: () => ({
    rules,
  }),
  computed: {
    ...mapState('menuSyncSettings', ['restaurants', 'restaurantsFailed', 'categories', 'categoriesFailed']),

    categoryItems() {
      const items = this.categories.map(x => ({
        id: x.id,
        title: `${x.path} · ${x.products} поз., бесплатных ${x.freeProducts}`,
      }))
      const known = new Set(items.map(x => x.id))
      const missing = [...this.presentCategoryIds, ...this.applianceCategoryIds]
        .filter(id => !known.has(id))
        .map(id => ({ id, title: `${id} — нет в меню Delivery` }))

      return [...items, ...missing]
    },

    restaurantItems() {
      return [
        { id: 0, title: 'Не ограничивать' },
        ...this.restaurants.map(x => ({ id: x.id, title: `${x.name} (${x.id})` })),
      ]
    },

    ...mapFormHandlers('menuSyncSettings', [
      'filterByClassificator',
      'classificatorGroupId',
      'onlyActive',
      'restaurantId',
      'presentCategoryIds',
      'applianceCategoryIds',
    ]),
  },
  async created() {
    await Promise.all([this.fetch(), this.fetchRestaurants(), this.fetchCategories()])
  },
  methods: {
    ...mapActions('menuSyncSettings', ['update', 'fetch', 'fetchRestaurants', 'fetchCategories']),
    cancel() {
      this.$router.back()
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update()
      }
    },
  },
}
</script>
